/**
 * Credit Balance Widget
 * Displays user's feature credit balance and purchase button
 */

import {
  Box,
  HStack,
  Text,
  Button,
  Icon,
  Spinner
} from '@chakra-ui/react';
import { FiCreditCard, FiPlus } from 'react-icons/fi';
import { useCreditContext } from '../../context/CreditContext';

const CreditBalanceWidget = ({ onPurchaseClick, showDetails = false }) => {
  const { credits, loading } = useCreditContext();

  if (loading && !credits) {
    return (
      <Box p={3} bg="dark.500" borderRadius="md">
        <HStack spacing={2}>
          <Spinner size="sm" color="dark.900" />
          <Text fontSize="sm" color="primary.900">Loading credits...</Text>
        </HStack>
      </Box>
    );
  }

  const availableCredits = credits?.available_credits || 0;
  const subscriptionCredits = credits?.subscription_credits || 0;
  const purchasedCredits = credits?.purchased_credits || 0;

  // Build breakdown text
  const breakdownParts = [];
  if (subscriptionCredits > 0) breakdownParts.push(`${subscriptionCredits} subscription`);
  if (purchasedCredits > 0) breakdownParts.push(`${purchasedCredits} purchased`);
  const breakdownText = breakdownParts.length > 0 ? breakdownParts.join(', ') : null;

  return (
    <Box p={3} bg="dark.500" borderRadius="md" boxShadow="2xl">
      <HStack justify="space-between" align="center" spacing={4}>
        <HStack spacing={3}>
          <Icon as={FiCreditCard} boxSize={5} color="dark.900" />
          <HStack spacing={2} align="baseline">
            <Text fontSize="lg" fontWeight="bold" color="dark.900">
              {availableCredits}
            </Text>
            <Text fontSize="xs" color="primary.900">
              credits
            </Text>
            {showDetails && breakdownText && (
              <Text fontSize="xs" color="primary.900">
                ({breakdownText})
              </Text>
            )}
          </HStack>
        </HStack>

        <Button
          leftIcon={<Icon as={FiPlus} />}
          variant="glassy"
          size="xs"
          onClick={onPurchaseClick}
        >
          Buy Credits
        </Button>
      </HStack>

      {showDetails && credits?.total_credits_used > 0 && (
        <Text mt={1} pl={8} fontSize="xs" color="primary.900">
          {credits.total_credits_used} used
        </Text>
      )}
    </Box>
  );
};

export default CreditBalanceWidget;
